
export default {
  name: 'UserTabs',
  components: {},
  props: {
    state: {
      // 为 2展示邮箱登录
      type: [Number, String],
      default: 1
    },
    tabs: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      switchate: this.$store.state.myCountry.toLowerCase() == 'cn' ? 1 : 2 // 1为手机号验证码登录/2为手机号邮箱登录
    }
  },
  watch: {
    switchate: {
      handler(newName) {
        this.$emit('switch', newName)
        this.switchate = newName
      }
      // immediate: true
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.state != 1) this.switchate = 2
    }, 0)
  },
  methods: {}
}
